import { Button } from "@pentabd/ui";
import { ExistingProductsTable } from "./components";
import { IconPlus } from "@pentabd/icons";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@constants/routes";
import { useTranslation } from "react-i18next";

export interface ExistingProductPropsType {
  id: any; //!!!
  setSearchParams: Function;
  changeActiveTab: (arg: number) => void;
  procurementType: string;
  // setIsSuccessModalOpen: (arg: boolean) => void;
  // setIsErrorModalOpen: (arg: boolean) => void;
}

const { CREATE } = ROUTES;

const ExistingProductsList = ({
  id,
  changeActiveTab,
  procurementType,
  // setIsSuccessModalOpen,
  // setIsErrorModalOpen,
  setSearchParams,
}: ExistingProductPropsType) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSetProcurementType = () => {
    localStorage.setItem("procurementType", procurementType);
    navigate(CREATE);
  };

  return (
    <div className="p-10">
      <div className="text-end">
        <Button type="primary" onClick={handleSetProcurementType}>
          <IconPlus size="20" fill="white" />
          {t("PROCUREMENTS_LIST.ADD_NEW")}
        </Button>
      </div>
      <ExistingProductsTable />
    </div>
  );
};

export default ExistingProductsList;
